var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-field" },
    [
      _c(
        "VTooltip",
        {
          staticClass: "self",
          class: {
            "force-toolbar": _vm.contextMenuOpen || _vm.editing
          },
          style: { marginLeft: _vm.depth * 14 + "px" },
          attrs: { disabled: !_vm.field.meta, placement: "left", offset: "24" },
          nativeOn: {
            click: function($event) {
              return _vm.onClick($event)
            },
            mouseenter: function($event) {
              return _vm.onContextMenuMouseEnter($event)
            },
            mouseleave: function($event) {
              return _vm.onContextMenuMouseLeave($event)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "popper",
              fn: function() {
                return [
                  _vm.field.meta
                    ? _c(
                        "div",
                        { staticClass: "meta" },
                        _vm._l(_vm.field.meta, function(val, key) {
                          return _c(
                            "div",
                            { key: key, staticClass: "meta-field" },
                            [
                              _c("span", { staticClass: "key" }, [
                                _vm._v(_vm._s(key))
                              ]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(val))
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("span", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isExpandableType,
                expression: "isExpandableType"
              }
            ],
            staticClass: "arrow right",
            class: { rotated: _vm.expanded }
          }),
          _vm.editing && _vm.renamable
            ? _c("span", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedKey,
                      expression: "editedKey"
                    }
                  ],
                  ref: "keyInput",
                  staticClass: "edit-input key-input",
                  class: { error: !_vm.keyValid },
                  domProps: { value: _vm.editedKey },
                  on: {
                    "!keydown": function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.cancelEdit()
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.submitEdit()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.editedKey = $event.target.value
                    }
                  }
                })
              ])
            : _c(
                "span",
                {
                  staticClass: "key",
                  class: { abstract: _vm.fieldOptions.abstract }
                },
                [_vm._v(_vm._s(_vm.displayedKey))]
              ),
          !_vm.fieldOptions.abstract
            ? _c("span", { staticClass: "colon" }, [_vm._v(":")])
            : _vm._e(),
          _vm.editing
            ? _c("span", { staticClass: "edit-overlay" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedValue,
                      expression: "editedValue"
                    }
                  ],
                  ref: "editInput",
                  staticClass: "edit-input value-input",
                  class: { error: !_vm.valueValid },
                  attrs: { list: "special-tokens" },
                  domProps: { value: _vm.editedValue },
                  on: {
                    "!keydown": function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.cancelEdit()
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.submitEdit()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.editedValue = $event.target.value
                    }
                  }
                }),
                _c(
                  "span",
                  { staticClass: "actions" },
                  [
                    !_vm.editValid
                      ? _c("VueIcon", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.editErrorMessage,
                              expression: "editErrorMessage"
                            }
                          ],
                          staticClass: "small-icon warning",
                          attrs: { icon: "warning" }
                        })
                      : [
                          _c("VueButton", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$t("DataField.edit.cancel.tooltip"),
                                expression:
                                  "$t('DataField.edit.cancel.tooltip')"
                              }
                            ],
                            staticClass: "icon-button flat",
                            attrs: { "icon-left": "cancel" },
                            on: {
                              click: function($event) {
                                return _vm.cancelEdit()
                              }
                            }
                          }),
                          _c("VueButton", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$t("DataField.edit.submit.tooltip"),
                                expression:
                                  "$t('DataField.edit.submit.tooltip')"
                              }
                            ],
                            staticClass: "icon-button flat",
                            attrs: { "icon-left": "save" },
                            on: {
                              click: function($event) {
                                return _vm.submitEdit()
                              }
                            }
                          })
                        ]
                  ],
                  2
                )
              ])
            : [
                _c("span", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.valueTooltip,
                      expression: "valueTooltip"
                    }
                  ],
                  staticClass: "value",
                  class: _vm.valueClass,
                  domProps: { innerHTML: _vm._s(_vm.formattedValue) },
                  on: {
                    dblclick: function($event) {
                      return _vm.openEdit()
                    }
                  }
                }),
                _c(
                  "span",
                  { staticClass: "actions" },
                  [
                    _vm.isValueEditable
                      ? _c("VueButton", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Edit value",
                              expression: "'Edit value'"
                            }
                          ],
                          staticClass: "edit-value icon-button flat",
                          attrs: { "icon-left": "edit" },
                          on: {
                            click: function($event) {
                              return _vm.openEdit()
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.quickEdits
                      ? _vm._l(_vm.quickEdits, function(info, index) {
                          return _c("VueButton", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: info.title || "Quick edit",
                                expression: "info.title || 'Quick edit'"
                              }
                            ],
                            key: index,
                            staticClass: "quick-edit icon-button flat",
                            class: info.class,
                            attrs: { "icon-left": info.icon },
                            on: {
                              click: function($event) {
                                return _vm.quickEdit(info, $event)
                              }
                            }
                          })
                        })
                      : _vm._e(),
                    _vm.isSubfieldsEditable && !_vm.addingValue
                      ? _c("VueButton", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Add new value",
                              expression: "'Add new value'"
                            }
                          ],
                          staticClass: "add-value icon-button flat",
                          attrs: { "icon-left": "add_circle" },
                          on: {
                            click: function($event) {
                              return _vm.addNewValue()
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.removable
                      ? _c("VueButton", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Remove value",
                              expression: "'Remove value'"
                            }
                          ],
                          staticClass: "remove-field icon-button flat",
                          attrs: { "icon-left": "delete" },
                          on: {
                            click: function($event) {
                              return _vm.removeField()
                            }
                          }
                        })
                      : _vm._e(),
                    _c(
                      "VueDropdown",
                      {
                        attrs: { open: _vm.contextMenuOpen },
                        on: {
                          "update:open": function($event) {
                            _vm.contextMenuOpen = $event
                          }
                        }
                      },
                      [
                        _c("VueButton", {
                          staticClass: "icon-button flat",
                          attrs: { slot: "trigger", "icon-left": "more_vert" },
                          slot: "trigger"
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "context-menu-dropdown",
                            on: {
                              mouseenter: _vm.onContextMenuMouseEnter,
                              mouseleave: _vm.onContextMenuMouseLeave
                            }
                          },
                          [
                            _c(
                              "VueDropdownButton",
                              {
                                attrs: { "icon-left": "flip_to_front" },
                                on: { click: _vm.copyToClipboard }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("DataField.contextMenu.copyValue")
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              ]
        ],
        2
      ),
      _vm.expanded && _vm.isExpandableType
        ? _c(
            "div",
            { staticClass: "children" },
            [
              _vm._l(_vm.formattedSubFields, function(subField) {
                return _c("data-field", {
                  key: subField.key,
                  attrs: {
                    field: subField,
                    "parent-field": _vm.field,
                    depth: _vm.depth + 1,
                    path: _vm.path + "." + subField.key,
                    editable: _vm.isEditable,
                    removable: _vm.isSubfieldsEditable,
                    renamable: _vm.editable && _vm.valueType === "plain-object",
                    "force-collapse": _vm.forceCollapse,
                    "is-state-field": _vm.isStateField
                  }
                })
              }),
              _vm.subFieldCount > _vm.limit
                ? _c("VueButton", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Show more",
                        expression: "'Show more'"
                      }
                    ],
                    staticClass: "icon-button flat more",
                    style: { marginLeft: _vm.depthMargin + "px" },
                    attrs: { "icon-left": "more_horiz" },
                    on: {
                      click: function($event) {
                        return _vm.showMoreSubfields()
                      }
                    }
                  })
                : _vm._e(),
              _vm.isSubfieldsEditable && _vm.addingValue
                ? _c("data-field", {
                    ref: "newField",
                    attrs: {
                      field: _vm.newField,
                      depth: _vm.depth + 1,
                      path: _vm.path + "." + _vm.newField.key,
                      renamable: _vm.valueType === "plain-object",
                      "force-collapse": _vm.forceCollapse,
                      editable: "",
                      removable: "",
                      "is-state-field": _vm.isStateField
                    },
                    on: {
                      "cancel-edit": function($event) {
                        _vm.addingValue = false
                      },
                      "submit-edit": function($event) {
                        _vm.addingValue = false
                      }
                    }
                  })
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }